<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="8">
            <a-form-item :label="language['application.applicationName']">
              <a-input placeholder="" v-model="queryParam.applicationName" allowClear></a-input>
            </a-form-item>
          </a-col>

          <!-- <a-col :md="6" :sm="8">
            <a-form-item label="状态">
              <j-dict-select-tag v-model="queryParam.applicationStatus" placeholder="" dictCode="application_status"/>
            </a-form-item>
          </a-col> -->
          
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="clickToApp" type="primary" icon="plus">{{ language['application.addApp'] }}</a-button>
      <a-button @click="goback" type="primary" icon="left">{{language['portal.goBack']}}</a-button>
     <!--  <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="action" slot-scope="text, record">
          <a-popconfirm :title="language['common.deleteConfirmInfo'] " @confirm="() => handleDelete(record.appId)">
                  <a>{{language['common.delete']}}</a>
          </a-popconfirm>

          <a-divider type="vertical"/>      
          <span v-if="record.topFlag == 'N'" ><a @click="setTop(record)">{{ language['application.top'] }}</a></span>
          <span v-if="record.topFlag == 'Y'" ><a @click="cancelTop(record)">{{ language['application.cancleTop'] }}</a></span>
        </template>

        <template slot="applicationImgPath" slot-scope="text, record, index">
              <div class="anty-img-wrap">
                <a-avatar shape="square" :src="getAvatarView(record.applicationImgPath)" icon="user"/>
              </div>
        </template>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <!-- <sysPosition-modal ref="modalForm" @ok="modalFormOk"></sysPosition-modal> -->
    <AppModal ref="appRef"  @clickOK="clickOK" ></AppModal>
  </a-card>
</template>

<script>
  // import SysPositionModal from './modules/SysPositionModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JDictSelectTag from '@/components/dict/JDictSelectTag'
  import {  httpAction ,getAction,postAction,getFileAccessHttpUrl} from '@/api/manage' 
  import AppModal from './modals/AppModal'

  export default {
    name: 'CmsContentAppList',
    mixins: [JeecgListMixin],
    components: {
      AppModal,
      JDictSelectTag
    },
    props: {
      colid: String,
     
    },
    data() {
      const { language } = this.$store.getters;
      return {
        description: '',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: language['application.applicationCode'],
            align: 'center',
            dataIndex: 'applicationCode'
          },
          {
            title: language['application.applicationName'],
            align: 'center',
            dataIndex: 'applicationName'
          },
          {
            title: language['application.applicationImgPath'],
            align: "center",
            // width: 100,
            dataIndex: 'applicationImgPath',
            scopedSlots: {customRender: "applicationImgPath"},
          },
          {
            title: language['emp.develop.appType'],
            align: "center",
            // width: 200,
            dataIndex: 'appType',
          },
          {
            title: language['application.applicationStatus'],
            align: "center",
            // width: 100,
            dataIndex: 'applicationStatus_dictText'
          },
          {
            title: language['common.action'],
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: '/sys/sysBmApplication/listForTemplate7',
          delete: '/sys/sysBmApplication/deleteAppForTemplate7',
          deleteBatch: '/sys/sysBmApplication/deleteBatch',
        
        },
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    created(){
      //  this.loadData(1)
    },
    methods:{
      searchQuery() {//重写 查询
          this.loadData(1);
      },

      searchReset() {//重写 重置
        this.queryParam = {}
        this.loadData(1);
      },

      loadData(arg){//重写 loadData
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        let params = this.getQueryParams();//查询条件
        console.log('params: ', params);

        params.colId = this.colid
        

        getAction(this.url.list, params).then((res) => {
          if (res.success && res.result) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },

      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar,'platform')
      },

      setTop(record){
        let appId = record.appId
        let topFlag = record.topFlag
        getAction('/sys/sysBmApplication/topAppData',{appId:appId,topFlag:topFlag}).then(res=>{
           if(res.success){
            this.$message.success(res.message)

            this.loadData(1)
           }
        })
      },

      cancelTop(record){
        let appId = record.appId
        let topFlag = record.topFlag
        getAction('/sys/sysBmApplication/topAppData',{appId:appId,topFlag:topFlag}).then(res=>{
           if(res.success){
            this.$message.success(res.message)

            this.loadData(1)
           }
        })
      },
      goback(){
        this.$parent.tabChange(null);
      },
      clickToApp(){
        this.$refs.appRef.visible = true
        this.$refs.appRef.searchReset(this.colid)
      },
      clickOK(){
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>